import Route from "vue-routisan";
import isAuthenticated from "../middlewares/isAuthenticated";
import isShipper from "@/http/routes/middlewares/isShipper";
import hasQuotationPermission from "@/http/routes/middlewares/hasPermission/hasQuotationPermission";

const options = {
  meta: {
    layout: () => import(/* webpackChunkName: "shipper" */ "@/resources/views/quotation/shipper/layout/Layout.vue")
  }
};

Route.group({}, () => {
  Route.group({prefix: "quotation", beforeEnter: [isShipper]}, () => {
    Route.group({prefix: "shipper", beforeEnter: [isAuthenticated, hasQuotationPermission]}, () => {
      /*---------------------------------------------------------------------------------------------------------------
      |                                               QUOTES                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.view("/", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/OrderQuotes")
      ).name("shipper.quotation.order_quotes").options(options);
      Route.view("/:id", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/QuoteDetails")
      ).name("shipper.quotation.order_quotes_details").options(options);
      Route.view("/transporters/:id", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/QuoteDetailsTransporters")
      ).name("shipper.quotation.order_quotes_details_transporters").options(options);
      Route.view("/shipping_request_quote", () =>
        import(/* webpackChunkName: "shipper" */ "@/resources/views/logistic_manager/shipper/order/ShippingRequestQuote")
      ).name("shipper.quotation.order_shipping_request_quote").options(options);
    });
  });
});

export default Route.all();
